'use client';

import * as React from 'react';

/**
 * @ignore - internal component.
 */
const ListContext = /*#__PURE__*/React.createContext({});
if (process.env.NODE_ENV !== 'production') {
  ListContext.displayName = 'ListContext';
}
export default ListContext;


//////////////////
// WEBPACK FOOTER
// ../@mui/material/List/ListContext.js
// module id = 116
// module chunks = 22